// ----------------------------------------------------------------------
// <copyright file="Izenda.ImportDataModelConstants.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------
//

import localizer from 'share/localization/Izenda.Localizer';

export default { 
  get DESTINATION_CONSTRAINTS() {
    return {
      presence: {
        presence: true,
        message: localizer.getText('COPY_MANAGEMENT_MESSAGE_DESTINATION_CONSTRAINT')
      }
    };
  },
  get systemSource() {
    return {
      id: '00000000-0000-0000-0000-000000000000',
      name: localizer.getText('COMMON_LABEL_SYSTEM')
    };
  },
  get M01() {
    return localizer.getText('COPY_MANAGEMENT_MESSAGE_CONFIRM_DELETE_WORKSPACE');
  },
  get M11() {
    return localizer.getText('COPY_MANAGEMENT_MESSAGE_CONFIRM_DELETE_TENANT');
  },
  get TABLE_DESTINATION_DEFINITION() {
    return {
      tenantName: {
        key: 'tenantName',
        columnKey: 'tenantName',
        width: 80,
        title: localizer.getText('COMMON_LABEL_TENANT'),
        sortable: true
      },
      status: {
        key: 'status',
        columnKey: 'status',
        width: 80,
        title: localizer.getText('COMMON_LABEL_STATUS'),
        sortable: true
      },
      action: {
        key: 'status',
        columnKey: 'action',
        width: 100,
        align: 'center',
        title: localizer.getText('COMMON_LABEL_ACTION'),
        sortable: false,
        fixed: true
      }
    };
  },
  get STATUS_OF_DESTINATION() {
    return {
      '0': {
        status: localizer.getText('COPY_MANAGEMENT_MESSAGE_STATUS_DEST_NEED_VALIDATION'),
        class: 'need-validated',
        iconClass: '',
        iconOkClass: ''
      },
      '1': {
        status: localizer.getText('IMPORT_DATAMODEL_MESSAGE_STATUS_READY_TO_IMPORT'),
        class: 'ready-to-copy',
        iconClass: '',
        iconOkClass: 'ready-to-copy'
      },
      '2': {
        status: localizer.getText('COPY_MANAGEMENT_MESSAGE_STATUS_DEST_MISSING_AUTHEN'),
        class: 'authentication-missing',
        iconClass: 'icon-info-circled',
        iconOkClass: 'ready-to-copy'
      },
      '3': {
        status: localizer.getText('COPY_MANAGEMENT_MESSAGE_STATUS_DEST_VALIDATION_ERROR'),
        class: 'validation-error',
        iconClass: 'icon-info-circled',
        iconOkClass: 'icon-disabled'
      },
      NEED_VALIDATION: 0,
      READY_TO_COPY: 1,
      AUTHENTICATION_MISSION: 2,
      VALIDATION_ERROR: 3
    };
  },
  get VALIDATION_ERROR_TOOLTIP() {
    return localizer.getText('COPY_MANAGEMENT_VALIDATION_ERROR_TOOLTIP');
  },
  get COPY_MANAGEMENT_OBJECT_TOOLTIP() {
    return localizer.getText('COPY_MANAGEMENT_OBJECT_TOOLTIP');
  },
  get TABLE_DEF() {
    return {
      TENANT_MAPPING: {
        fromDatabaseName: {
          key: 'fromConnectionName',
          columnKey: 'fromConnectionName',
          width: 170,
          title: localizer.getText('IMPORT_DATAMODEL_LABEL_TABLE_CONNECTION')
        },
        fromObject: {
          key: 'fromSchemaName',
          columnKey: 'fromSchemaName',
          width: 150,
          title: localizer.getText('IMPORT_DATAMODEL_LABEL_TABLE_SCHEMA')
        },
        toDatabaseName: {
          key: 'toConnectionName',
          columnKey: 'toConnectionName',
          width: 150,
          title: localizer.getText('IMPORT_DATAMODEL_LABEL_TABLE_CONNECTION')
        },
        toObject: {
          key: 'toSchemaName',
          columnKey: 'toSchemaName',
          width: 150,
          title: localizer.getText('IMPORT_DATAMODEL_LABEL_TABLE_SCHEMA')
        },
        action: {
          width: 70,
          fixed: true,
          align: 'center',
          title: localizer.getText('COMMON_LABEL_ACTION'),
          className: 'align-bottom'
        }
      }
    };
  },
  DESTINATION_SORT_DIR: {
    version: 'DESC'
  },
  get MAPPING_HEADER() {
    return {
      GLOBAL: localizer.getText('COPY_MANAGEMENT_LABEL_MAPPING_HEADER_GLOBAL'),
      TENANT: localizer.getText('COPY_MANAGEMENT_LABEL_MAPPING_HEADER_TENANT'),
      ALL_MAPPING_TOOLTIP: localizer.getText('COPY_MANAGEMENT_ALL_MAPPING_TOOLTIP'),
      MERGE_DUPLICATE_TOOLTIP: localizer.getText('COPY_MANAGEMENT_MERGE_DUPLICATE_TOOLTIP'),
      SPECIFIC_MAPPING_TOOLTIP: localizer.getText('COPY_MANAGEMENT_SPECIFIC_MAPPING_TOOLTIP')
    };
  },
  get REQUIRE_CONSTRAINT() {
    return {
      presence: {
        presence: true,
        message: localizer.getText('COMMON_CONSTRAINT_REQUIRED')
      }
    };
  },
  DETECTED_CHANGE_LEVEL: {
    NONE: 0,
    ADDED: 1,
    MODIFIED: 2
  },
  get CONSISTENT_DATA_MODEL() {
    return localizer.getText('COPY_MANAGEMENT_MESSAGE_CONSISTENT_DATA_MODEL');
  },
  get INCONSISTENT_DATA_MODEL() {
    return localizer.getText('COPY_MANAGEMENT_MESSAGE_INCONSISTENT_DATA_MODEL');
  },
  get CHANGED_DATA_TYPE() {
    return localizer.getText('COPY_MANAGEMENT_MESSAGE_CHANGED_DATA_TYPE');
  },
  get DELETED_DATA_SOURCE() {
    return localizer.getText('COPY_MANAGEMENT_MESSAGE_DELETED_DATA_SOURCE');
  },

  APPROVAL_LEVEL: {
    PENDING: 0,
    QUERY_SOURCE: 1,
    QUERY_SOURCE_FIELD: 2
  },
  DATETIME_FORMAT: 'MM/dd/yyyy HH:mm:ss tt',
  get RUN_IMPORT_SUCCESS() {
    return localizer.getText('IMPORT_DATAMODEL_MESSAGE_IMPORT_PROCESS_DONE');
  },
  NODE_TYPE: {
    STORE_PROCEDURE: 'Stored Procedure',
    FUNCTION: 'Function',
    TABLE: 'Table',
    VIEW: 'View'
  }
};



// WEBPACK FOOTER //
// ./ui/logic/data/Izenda.ImportDataModelConstants.js